/**
 * 本文件由 scripts/generate-spm-codes.mjs 生成，请勿手改；编码以评审确认后的 CSV 快照为准。
 * App 内嵌终端：coupons_app（由同名 WAP 终端全量派生，B 位 *_wap 重写为 coupons_app，C/D 不变；2 个 D 位坑位，2 个 C 位模块）。
 * 数据源：coupons_wap（全量派生）。
 * 模块级曝光上报 module.code（A.B.C）；坑位级曝光与点击上报完整编码（A.B.C.D）。
 */
import type { SpmPageCodes } from '../types';
import { getSpmSitePrefix } from '../site';

const sitePrefix = getSpmSitePrefix();

export const COUPONS_APP_SPM_CODES = {
  first_order_coupons: {
    code: `${sitePrefix}.coupons_app.first_order_coupons`,
    'coupon_cta_{NN}': `${sitePrefix}.coupons_app.first_order_coupons.coupon_cta_{NN}`,
  },
  general_coupons: {
    code: `${sitePrefix}.coupons_app.general_coupons`,
    'coupon_cta_{NN}': `${sitePrefix}.coupons_app.general_coupons.coupon_cta_{NN}`,
  },
} as const satisfies SpmPageCodes;
